// Libs
import { UniqueIdentifier } from '@dnd-kit/core';
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { Stack, Typography } from '@mui/material';
import { CSS } from '@dnd-kit/utilities';
import classNames from 'classnames/bind';
// Components, Layouts, Pages
// Others
import { ColumnTypeKanban, IBaseKanban } from '~/utils/interface/common';
// Styles, images, icons
import styles from './DroppableContainer.module.scss';

type Props<T extends IBaseKanban> = {
  children: React.ReactNode;
  label: string;
  date?: string;
  id: UniqueIdentifier;
  data: ColumnTypeKanban<T>;
  minWidth?: number;
};

const cx = classNames.bind(styles);

const animateLayoutChanges: AnimateLayoutChanges = (args) =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true });

const DroppableContainer = <T extends IBaseKanban>(props: Props<T>) => {
  //#region Destructuring Props
  const { children, label, date, data, id, minWidth = 210 } = props;
  //#endregion Destructuring Props

  //#region Declare Hook

  const { attributes, setNodeRef, transition, transform } = useSortable({
    id,
    data: {
      type: 'container',
      children: data,
    },
    animateLayoutChanges,
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack
      direction={'column'}
      style={{
        transition,
        transform: CSS.Translate.toString(transform),
        minWidth: `${minWidth}px`,
      }}
      {...attributes}
      ref={setNodeRef}
      className={cx('droppableContainer')}
    >
      <Stack direction={'column'} alignItems={'center'} className={cx('header')}>
        <Typography className={cx('label')}>{label}</Typography>
        <Typography className={cx('label')}>{date}</Typography>
      </Stack>

      <Stack direction={'column'} gap={'5px'} className={cx('itemWrap')}>
        {children}
      </Stack>
    </Stack>
  );
};

export default DroppableContainer;
